import { AdvisoryInfoIcon } from '../../components/icons/Icons.tsx';
import { SecondaryAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryLink } from './AdvisoryLink.tsx';

// we no longer use this advisory, but keeping it around, b/c I could see using it if we know we're too far out of sync
export const TFRListAdvisory = () => {
    return (
        <SecondaryAdvisory header="Temporary Flight Restrictions" advisoryType='advise' icon={AdvisoryInfoIcon} iconColor="medium">
            Operator is responsible for reviewing and complying with all temporary flight restrictions (TFRs) at <AdvisoryLink url="https://tfr.faa.gov" />.
        </SecondaryAdvisory>
    );
};
